<button mat-button [matMenuTriggerFor]="medicMenu">Medic: {{ medic().nume }} {{ medic().prenume }}</button>
<mat-menu #medicMenu="matMenu" overlapTrigger="false">
  <!-- <button mat-menu-item (click)="medicSelect('dashboard', medicId)">Sumar</button> -->
  <button mat-menu-item (click)="medicSelect('date-personale')">Date personale</button>
  <button mat-menu-item (click)="medicSelect('ppu')">Pregătire Postuniversitară</button>
  <button mat-menu-item (click)="medicSelect('alte-titluri')">Titluri Profesionale</button>
  <button mat-menu-item (click)="medicSelect('adresa')">Contact</button>
  <button mat-menu-item (click)="medicSelect('emc')">E.M.C.</button>
  <mat-divider />
  <button mat-menu-item [matMenuTriggerFor]="medicDocumente">Documente</button>
  @if (taxe.includes(currentUser()?.judet_id ?? 0)) {
    <div>
      <mat-divider />
      <button mat-menu-item (click)="medicSelect('taxe')">Taxe</button>
    </div>
  }
  <mat-divider />
  <button mat-menu-item [matMenuTriggerFor]="medicActiuni">Actiuni</button>
</mat-menu>

<mat-menu #medicDocumente="matMenu">
  <button mat-menu-item (click)="medicSelect('certificat')">Certificat de membru</button>
  <button mat-menu-item (click)="medicSelect('avizare')">Avizare</button>
  <button mat-menu-item (click)="medicSelect('cpc')">Certificat profesional curent</button>
</mat-menu>

<mat-menu #medicActiuni="matMenu">
  <button mat-menu-item (click)="medicSelect('transfer')">Transfer</button>
  <button mat-menu-item (click)="medicSelect('status')">Status</button>
</mat-menu>
